<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="9781937084646_txt_0004_001" class="imgpub" id="d14e98" src="images/9781937084646_txt_0004_001.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Park_9781937084721_epub_c4_r1.vue?726c7bd0